/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2020 Priska Wermelinger & Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import LogInModal from 'flarum/forum/components/LogInModal';
import EditBookshelfModal from '../components/EditBookshelfModal';
import type Bookshelf from '../../common/models/Bookshelf';

export default function (bookshelf: Bookshelf | null, onSaved: (bookshelf: Bookshelf) => void): void {
	if (app.session.user?.canCreateBookshelves()) {
		const onsubmit = (_bookshelf: Bookshelf) => {
			_bookshelf
				.save({
					name: _bookshelf.name(),
					isPrivate: _bookshelf.isPrivate(),
				})
				.then(onSaved);
		};

		// Stacked, so a host modal rendering this stays mounted and keeps its state; `close()` pops back to it.
		app.modal.show(EditBookshelfModal, { bookshelf, onsubmit }, true);
	} else {
		app.modal.show(LogInModal);
	}
}
